/**
 * API origin for the browser.
 *
 * Prefer leaving this empty so calls stay same-origin (`/api/...`):
 * - Local Vite → proxies `/api` to Worker/Express on :4000
 * - Cloudflare Pages → `functions/api` proxies `/api` → https://api.ileafs.store
 *
 * Optional override: `VITE_API_URL=https://api.ileafs.store`
 */
export function getApiBase(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim() || '';
  return raw.replace(/\/$/, '');
}

/** Build a full API URL (or relative `/api/...` when base is empty). */
export function apiUrl(path: string): string {
  const base = getApiBase();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalized}` : normalized;
}
